import React, { useState } from "react";

import {
  Box,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import { ServiceApi } from "../services/index.service";
import { useSnackbar } from "notistack";
import AddPromotionDialog from "./AddPromotionDialog";
import DriveThruPreSellBoardAdmin from "./DriveThruPreSellBoardAdmin";
import DMBPreSellBoardAdmin from "./DMBPreSellBoardAdmin";
import moment from "moment/moment";
import dayjs from "dayjs";
import CreativesList from './Creatives/CreativesList';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const PreSellAdmin = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [value, setValue] = useState(0);
  const [btnloading, setBtnLoading] = useState(false);
  const [success,setSuccess]=useState(false)
  const initival = {
    intBannerID: 0,
    vchBannerName: "",
    vchBannerURL: "",
    bitActive: 0,
    bitMandatory: 0,
    dteStartDate:dayjs().format('YYYY-MM-DD HH:mm:ss'),
    dteEndDate:dayjs().format('YYYY-MM-DD HH:mm:ss'),
    bitBannerType: 1,
    dteDateCreated:dayjs().format('YYYY-MM-DD HH:mm:ss'),
    bitVertical: 1,
  };
  const [selectedPromotion, setSelectedPromotion] = useState(initival);
  const [action, setAction] = useState("Add");
  const [showDialog, setShowDialog] = useState(false);

  const initialCreative = {
    intCreativeID: 0,
    vchCreativeName: "",
    bitActive: 0,
    vchImageURL1: '',
    vchImageURL2: '',
    vchImageURL3: '',
    dteStartDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
    dteEndDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
  };
  const [showCreativeDialog, setCreativeShowDialog] = useState(false);
  const [selectedCreative, setSelectedCreative] = useState(initialCreative)

  const handleCloseDialog = () => {
    setShowDialog(false);
    setSelectedPromotion(initival);
    setAction("Add");
  };
  const handleAddPromotion = () => {
    if (value === 2) {
      setAction("Add");
      setSelectedCreative(initialCreative)
      setCreativeShowDialog(true);
    } else {
      setAction("Add");
      setSelectedPromotion(initival);
      setShowDialog(true);
    }
  };

  const serviceapi = new ServiceApi();

  const handlePromotion = (value, name) => {
    if (name === "Mandatory" && !value) {
      setSelectedPromotion({
        ...selectedPromotion,
        [name]: value,
        dteStartDate:dayjs().format('YYYY-MM-DD HH:mm:ss'),
        dteEndDate:dayjs().format('YYYY-MM-DD HH:mm:ss'),
      });
    } else if (name === "bitBannerType") {
      setSelectedPromotion({ ...selectedPromotion, [name]: value });
    } else {
      setSelectedPromotion({ ...selectedPromotion, [name]: value });
    }
  };

  const onSubmit = async () => {
    let req = {
      ...selectedPromotion,
      vchBannerName: selectedPromotion?.vchBannerName,
      vchBannerURL: selectedPromotion?.vchBannerURL,
      bitActive: selectedPromotion?.bitActive ? 1 : 0,
      bitMandatory: selectedPromotion?.bitMandatory ? 1 : 0,
      dteStartDate: selectedPromotion?.bitMandatory
        ?  dayjs(selectedPromotion?.dteStartDate).format('YYYY-MM-DD HH:mm:ss')
        : dayjs().format('YYYY-MM-DD HH:mm:ss'),
      dteEndDate: selectedPromotion?.bitMandatory
        ? dayjs(selectedPromotion?.dteEndDate).format('YYYY-MM-DD HH:mm:ss')
        :dayjs().format('YYYY-MM-DD HH:mm:ss'),
      bitBannerType: selectedPromotion?.bitBannerType,
      bitVertical: selectedPromotion?.bitVertical ? 1 : 0,
    };
    setBtnLoading(true);
    if (action === "Add") {
      req = { ...req, intBannerID: 0 };
    }
    console.log(req,'req')
    setSuccess(false)
    const res = await serviceapi.savePresellBoardAdmin(req);
    setBtnLoading(false);
    if (res?.success) {
      let message = "Promotion Added Successfully";
      if (action === "Update") {
        message = "Promotion Updated Successfully";
      }
      setSuccess(true)
      setShowDialog(false);
      setSelectedPromotion(initival);
      setCreativeShowDialog(false);
      enqueueSnackbar(message, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "success",
      });
    } else {
      let message = "Error in Adding Promotion";
      if (action === "Update") {
        message = "Error in Updating Promotion";
      }
      enqueueSnackbar(message, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      });
    }
  };

  const tabsList = [
    {
      id: 1,
      title: "Drive-Thru",
      label: "Drive-Thru",
      disabled: false,
    },
    {
      id: 2,
      label: "Digital Display",
      title: "Digital Display",
      disabled: false,
    },
    {
      id: 3,
      label: "DMB Promos",
      title: "DMB Promos",
      disabled: false,
    },
  ];

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setCreativeShowDialog(false);
  };

  return (
    <div className="py-6 mt-16">
      <header>
        <div className="flex justify-between items-center mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <h1 className="text-2xl font-display font-medium leading-tight text-secondary">
            Pre-Sell Board Admin
          </h1>
          <div>
            <button
              style={{ height: "38px" }}
              type="button"
              onClick={() => handleAddPromotion()}
              className="inline-flex items-center justify-center rounded-md border border-transparent bg-primary px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary-light focus:ring-offset-2 sm:w-auto"
            >
              {value && value === 2 ? 'Add Creative' : 'Add Promotion'}
            </button>
          </div>
        </div>
      </header>
      <main>
        <div className="mx-auto max-w-7xl sm:px-6 lg:px-8 py-8">
          <div className="rounded-md bg-white shadow-md">
            <Box sx={{ width: "100%" }} className="px-4">
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs value={value} onChange={handleChange}>
                  {tabsList?.map((itm, index) => (
                    <Tab
                      label={itm.label}
                      {...a11yProps(itm.id)}
                      key={itm.id}
                      disabled={itm.disabled}
                    />
                  ))}
                </Tabs>
              </Box>
              {tabsList?.map((tabItem, index) => {
                return (
                  <TabPanel key={tabItem.id} value={value} index={index}>
                    {tabItem.id === 1 && <DriveThruPreSellBoardAdmin success={success} />}
                    {tabItem.id === 2 && <DMBPreSellBoardAdmin success={success} />}
                    {tabItem.id === 3 && <CreativesList success={success} operation={action} showCreativeDialog={showCreativeDialog} setCreativeShowDialog={setCreativeShowDialog} />}
                  </TabPanel>
                );
              })}
            </Box>
          </div>
        </div>
      </main>
      {showDialog ? (
        <AddPromotionDialog
          showDialog={showDialog}
          handleCloseDialog={handleCloseDialog}
          action={action}
          IsAdmin={true}
          selectedPromotion={selectedPromotion}
          handlePromotion={handlePromotion}
          btnloading={btnloading}
          onSubmit={onSubmit}
          setSelectedPromotion={setSelectedPromotion}
        />
      ) : null}
    </div>
  );
};

export default PreSellAdmin;
